// Barrel for the staff display-name helpers (BL-1104 / BUG-1154 / BL-1170).
// Pure + client-safe.
export {
  NO_STAFF_NAME_ON_FILE,
  composeStaffDisplayName,
  isEmailPlaceholderName,
  resolveStaffDisplayName,
  splitStaffDisplayName,
  staffInitials,
  type StaffDisplayNameInput,
  type StaffNameParts,
} from './staff-display-name';
